import { useState, useEffect } from "react";
import moment from "moment";
// material
import {
  Box,
  Card,
  Typography,
  TableCell,
  TableBody,
  TableContainer,
  Table,
  TableRow,
  Button,
  Stack,
} from "@mui/material";
// components
import { sendDataWithPost } from "../../services/services";

import ListHead from "../../components/table/ListHead";
import Scrollbar from "../../components/table/Scrollbar";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../../components/TableRow";
import { isEmpty } from "lodash";

import FormSearch from "../../components/FormSearch";
import CircularLoader from "../../components/circularLoader";
import { CustomTableCell } from "../../components/TableCell";
import Pagination from "../../components/Pagination";
import { styles } from "../../utils/styles";
import Label from "../../components/Label";
import CommonDialog from "../../components/CustomDialog";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import MerchantPayoutInfoDetails from "./Dialogs/PendingDetail";

// ----------------------------------------------------------------------

const defaultValue = { is_active: true };

const TABLE_HEAD = [
  { id: "merchant_name", label: "Merchant" },
  { id: "terminal_id", label: "Terminal ID" },
  { id: "payment_host_name", label: "Payment Host" },
  { id: "payment_cycle", label: "Payment Cycle" },
  { id: "created_at", label: "Created At" },
  { id: "created_by", label: "Created By" },
  { id: "approved_by", label: "Approved By" },
  { id: "action", label: "Action" },
  { id: "approved", label: "Approved" },
];

export default function MerchantPayoutDetail() {
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState({
    results: [],
  });
  const [filter, setFilter] = useState(defaultValue);

  const [fLoaded, setFLoaded] = useState(false);
  const [itemId, setItemId] = useState(null);

  // ------------------ filterStuffies --------------------//
  const [pagination, setPagination] = useState({ page: 1, page_size: 50 });

  //Dialogs
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    queryPage(
      {
        page: newPage + 1,
        page_size: pagination.page_size,
      },
      filter
    );
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage(
      {
        page: 1,
        page_size: event.target.value,
      },
      filter
    );
  };

  const renderData = (res) => {
    const newData = res.results.map((item) => ({
      ...item,
      merchant_name: item.merchant?.name,
      terminal_id: item.terminal?.terminal_id,
      payment_host_name: item.payment_host?.name,
      approved: (
        <Label variant="ghost" color={item?.is_approved ? "success" : "error"}>
          {item?.is_approved ? "YES" : "NO"}
        </Label>
      ),
    }));

    setTableData({
      ...res,
      results: newData,
    });
  };

  const queryPage = (params, filter) => {
    loaded && setLoaded(false);
    const queryParams = new URLSearchParams(params || pagination).toString();
    const url = `/bank_account/merchant_payout_info_pending/filter_history/?${queryParams}`;
    sendDataWithPost(url, filter, renderData, setLoaded, () => {
      params && setPagination(params);
    });
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    queryPage(pagination, filter);
  }, []);

  const isUserNotFound = tableData?.results?.length === 0;

  const filteredList = applySortFilter(
    tableData?.results || [],
    order,
    orderBy
  );

  return (
    <Box>
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  headLabel={TABLE_HEAD}
                  checkbox={false}
                />
                <TableBody>
                  {filteredList?.map((row) => {
                    const {
                      id,
                      merchant_name,
                      terminal_id,
                      payment_host_name,
                      payment_cycle,
                      created_at,
                      created_by,
                      approved_by,
                      action,
                      approved,
                    } = row;

                    return (
                      <StyledTableRow
                        hover
                        key={id}
                        onClick={() => setItemId(id)}
                        sx={{ cursor: "pointer" }}
                      >
                        <CustomTableCell field={merchant_name} />
                        <CustomTableCell field={terminal_id} />
                        <CustomTableCell field={payment_host_name} />
                        <CustomTableCell field={payment_cycle} />
                        <CustomTableCell field={moment(created_at).format("DD-MM-YYYY HH:mm")} />
                        <CustomTableCell field={created_by?.email} />
                        <CustomTableCell field={approved_by?.email} />
                        <CustomTableCell field={action} />
                        <CustomTableCell field={approved} />
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                        <Typography
                          gutterBottom
                          align="center"
                          variant="subtitle1"
                        >
                          Not found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isEmpty(tableData?.results) && (
            <Pagination
              count={tableData.count}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
      ) : (
        <CircularLoader />
      )}


      {itemId && (
        <CommonDialog
          title={<HeaderHelpPage title="Merchant Payout Info Details" variant="h5" mb={0} />}
          onClose={() => setItemId(null)}
        >
          <MerchantPayoutInfoDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Box>
  );
}
